"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _dealerDetails = _interopRequireDefault(require("../styles/dealerDetails.css"));
var _rect, _rect2;
var BackButton = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(BackButton, _React$Component);
  function BackButton(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hover: false
    };
    _this.handleHover = _this.handleHover.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = BackButton.prototype;
  _proto.handleHover = function handleHover() {
    // eslint-disable-next-line
    return this.setState(function (prevState) {
      return {
        hover: !prevState
      };
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var clear = this.props.clear;
    var hover = this.state.hover;
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: _dealerDetails["default"].back,
      type: "button",
      onClick: function onClick() {
        return clear();
      },
      "aria-label": "Return to list",
      onMouseOver: function onMouseOver() {
        return _this2.setState({
          hover: true
        });
      },
      onFocus: function onFocus() {
        return _this2.setState({
          hover: true
        });
      },
      onMouseOut: function onMouseOut() {
        return _this2.setState({
          hover: false
        });
      },
      onBlur: function onBlur() {
        return _this2.setState({
          hover: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      width: "47px",
      height: "47px",
      viewBox: "0 0 47 47",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/_react["default"].createElement("g", {
      id: "Dealer-Locator",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/_react["default"].createElement("g", {
      id: "Desktop_Dealer_Locator_2.1_Hover_Tap_States",
      transform: "translate(-19.000000, -19.000000)"
    }, /*#__PURE__*/_react["default"].createElement("g", {
      id: "HOVER/TAP-STATES"
    }, /*#__PURE__*/_react["default"].createElement("g", {
      id: "btn_Go_Back",
      transform: "translate(20.000000, 20.000000)"
    }, /*#__PURE__*/_react["default"].createElement("circle", {
      id: "Oval-2",
      stroke: hover ? '#5A646E' : '#A3A9AD',
      fill: hover ? '#5A646E' : '#FFF',
      opacity: hover ? '0.5' : '1',
      cx: "22.5",
      cy: "22.5",
      r: "22.5"
    }), /*#__PURE__*/_react["default"].createElement("g", {
      id: "Group-5",
      transform: "translate(25.414214, 23.000000) rotate(-315.000000) translate(-25.414214, -23.000000) translate(18.414214, 16.000000)",
      fill: hover ? '#FFFFFF' : '#000000'
    }, _rect || (_rect = /*#__PURE__*/_react["default"].createElement("rect", {
      id: "line",
      transform: "translate(1.378680, 6.810660) rotate(-90.000000) translate(-1.378680, -6.810660) ",
      x: "-5.43198052",
      y: "5.81066017",
      width: "13.6213203",
      height: "2"
    })), _rect2 || (_rect2 = /*#__PURE__*/_react["default"].createElement("rect", {
      id: "line",
      transform: "translate(7.189340, 12.621320) scale(-1, -1) rotate(-360.000000) translate(-7.189340, -12.621320) ",
      x: "0.378679656",
      y: "11.6213203",
      width: "13.6213203",
      height: "2"
    })))))))));
  };
  return BackButton;
}(_react["default"].Component);
exports["default"] = BackButton;